// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

import { isEmpty } from '../generalUtils'

export const logError = (errorSource: string, error: unknown) => {
    console.log(`${errorSource} error:`, error)
    const deviceData = !isEmpty(window.androidData) ? window.androidData : window.iosData
    if (typeof newrelic == 'object') {
        newrelic.addPageAction('akaashpath_error', {
            errorSource,
            error,
            ...(deviceData || {})
        })
    }
}
